'use strict'

import {find, findAll} from "../libs/@elements/dom-utils";

const Selectors = {
    OriginalContainer: '.auto-translate-original__container',
    AnswerOriginalContainer: '.auto-translate-answer-original__container',
    ShowOriginal: '.js-auto-translate-product-review-original-show',
    AnswerShowOriginal: '.js-auto-translate-product-review-answer-original-show',
    OriginalText: '.js-auto-translate-product-review-original-text',
    AnswerOriginalText: '.js-auto-translate-product-review-answer-original-text',
    TranslationContainer: '.auto-translate-translation__container',
    AnswerTranslationContainer: '.auto-translate-answer-translation__container',
    ShowTranslation: '.js-auto-translate-product-review-translation-show',
    AnswerShowTranslation: '.js-auto-translate-product-review-answer-translation-show',
    TranslationText: '.js-auto-translate-product-review-translation-text',
    AnswerTranslationText: '.js-auto-translate-product-review-answer-translation-text'
}

export function init() {

    let showOriginal = findAll(Selectors.ShowOriginal);
    let showTranslation = findAll(Selectors.ShowTranslation);

    showOriginal.forEach(el => el.addEventListener('click', event => {
        event.stopPropagation();
        event.preventDefault();

        let reviewId = el.getAttribute("data-review-id");

        let originalContainer = findAll(Selectors.OriginalContainer+'[data-review-id="'+reviewId+'"]');
        let originalText = find(Selectors.OriginalText+'[data-review-id="'+reviewId+'"]');
        let translationContainer = findAll(Selectors.TranslationContainer+'[data-review-id="'+reviewId+'"]');
        let translationText = find(Selectors.TranslationText+'[data-review-id="'+reviewId+'"]');

        originalContainer.forEach(originalContainerElement => {
            originalContainerElement.classList.add('d-none');
        });
        originalText.classList.remove('d-none');

        translationContainer.forEach(translationContainerElement => {
            translationContainerElement.classList.remove('d-none');
        });
        translationText.classList.add('d-none');
    }));

    showTranslation.forEach(el => el.addEventListener('click', event => {
        event.stopPropagation();
        event.preventDefault();

        let reviewId = el.getAttribute("data-review-id");

        let originalContainer = findAll(Selectors.OriginalContainer+'[data-review-id="'+reviewId+'"]');
        let originalText = find(Selectors.OriginalText+'[data-review-id="'+reviewId+'"]');
        let translationContainer = findAll(Selectors.TranslationContainer+'[data-review-id="'+reviewId+'"]');
        let translationText = find(Selectors.TranslationText+'[data-review-id="'+reviewId+'"]');

        translationContainer.forEach(translationContainerElement => {
            translationContainerElement.classList.add('d-none');
        });
        translationText.classList.remove('d-none');

        originalContainer.forEach(originalContainerElement => {
            originalContainerElement.classList.remove('d-none');
        });
        originalText.classList.add('d-none');
    }));


    /*
     * Answer
     */
    let answerShowOriginal = findAll(Selectors.AnswerShowOriginal);
    let answerShowTranslation = findAll(Selectors.AnswerShowTranslation);

    answerShowOriginal.forEach(el => el.addEventListener('click', event => {
        event.stopPropagation();
        event.preventDefault();

        let reviewId = el.getAttribute("data-review-id");

        let answerOriginalContainer = findAll(Selectors.AnswerOriginalContainer+'[data-review-id="'+reviewId+'"]');
        let answerOriginalText = find(Selectors.AnswerOriginalText+'[data-review-id="'+reviewId+'"]');
        let answerTranslationContainer = findAll(Selectors.AnswerTranslationContainer+'[data-review-id="'+reviewId+'"]');
        let answerTranslationText = find(Selectors.AnswerTranslationText+'[data-review-id="'+reviewId+'"]');

        answerOriginalContainer.forEach(originalContainerElement => {
            originalContainerElement.classList.add('d-none');
        });

        if (answerOriginalText) {
            answerOriginalText.classList.remove('d-none');
        }

        answerTranslationContainer.forEach(translationContainerElement => {
            translationContainerElement.classList.remove('d-none');
        });

        if (answerTranslationText) {
            answerTranslationText.classList.add('d-none');
        }
    }));

    answerShowTranslation.forEach(el => el.addEventListener('click', event => {
        event.stopPropagation();
        event.preventDefault();

        let reviewId = el.getAttribute("data-review-id");

        let answerOriginalContainer = findAll(Selectors.AnswerOriginalContainer+'[data-review-id="'+reviewId+'"]');
        let answerOriginalText = find(Selectors.AnswerOriginalText+'[data-review-id="'+reviewId+'"]');
        let answerTranslationContainer = findAll(Selectors.AnswerTranslationContainer+'[data-review-id="'+reviewId+'"]');
        let answerTranslationText = find(Selectors.AnswerTranslationText+'[data-review-id="'+reviewId+'"]');

        answerTranslationContainer.forEach(translationContainerElement => {
            translationContainerElement.classList.add('d-none');
        });

        if (answerTranslationText) {
            answerTranslationText.classList.remove('d-none');
        }

        answerOriginalContainer.forEach(originalContainerElement => {
            originalContainerElement.classList.remove('d-none');
        });

        if (answerOriginalText) {
            answerOriginalText.classList.add('d-none');
        }
    }));
}